import React, {useEffect, useState} from 'react'
import {getAllColumn} from '../services/column'
import {useAuth} from '../modules/auth'
import useWebSocketHook from './useWebSocketHook'
import {webSocketOperations} from '../constants'

const useGetColumns = (boardId?: string) : {
  columnResponse: any[];
  setColumnsResponse: React.Dispatch<React.SetStateAction<any[]>>;
  fetchColumnHandler: (boardId: string, options?: { silent?: boolean }) => Promise<unknown>;
  isColumnLoading: boolean;
  isColumnLoadSkeleton: boolean;
  setIsColumnLoading: React.Dispatch<React.SetStateAction<boolean>>; // Update the type here
}=> {
  const [columnResponse, setColumnsResponse] = useState<any>([])
  const [isColumnLoading, setIsColumnLoading] = useState(true)
  const [isColumnLoadSkeleton, setIsColumnLoadSkeleton] = useState(true)
  const {currentUser} = useAuth()
  const {lastJsonMessage,sendJsonMessage,readyState}: any = useWebSocketHook()
  const {id} = currentUser?.data.user
  // `silent` refetches the columns without flipping the skeleton flag. The
  // skeleton swaps the whole columns area (BoardDnD), which unmounts any open
  // card modal — fine on first load, but fatal for a background column-create
  // fired from inside an open card (create-task-from-checklist): it would drop
  // the user to the kanban mid-flow and lose the unsaved checklist→task link.
  const fetchColumnHandler = async (boardId: string, options?: { silent?: boolean }) => {
    const silent = options?.silent ?? false
    if (!silent) setIsColumnLoadSkeleton(true)
    try {
      const columnResponse = await getAllColumn(boardId, id)
      const columns = columnResponse.data.data
      setColumnsResponse(columns)
    } catch (error) {
      return error
    } finally {
      setIsColumnLoading(false)
      if (!silent) setIsColumnLoadSkeleton(false)
    }
  }

  useEffect(() => {
    if (boardId) {
      fetchColumnHandler(boardId)
    }
    //eslint-disable-next-line
  }, [boardId])

  useEffect(() => {
    if (lastJsonMessage) {
      const operation: any = lastJsonMessage.response?.output.operation
      if (
        operation === webSocketOperations.columnDelete ||
        operation === webSocketOperations.columnCreate
      ) {
         if(boardId){
          fetchColumnHandler(boardId)
         }
      }
    }
    //eslint-disable-next-line
  }, [lastJsonMessage])

  useEffect(() => {
    if(readyState===1 ){
    
        sendJsonMessage({event:"subscribe",channel:boardId})      
      }
      //eslint-disable-next-line
}, [readyState])

  return {
    columnResponse,
    setColumnsResponse,
    fetchColumnHandler,
    isColumnLoading,
    isColumnLoadSkeleton,
    setIsColumnLoading,
  
}
}
export default useGetColumns
